import Script from 'next/script';
import { FC } from 'react';

import { isValidUrl } from '../helpers/links';

interface Props {
  url: string;
}

export const TwitterWidget: FC<Props> = ({ url }) => {
  if (!isValidUrl(url)) {
    return null;
  }

  return (
    <>
      <blockquote className="twitter-tweet">
        <a href={url}> </a>
      </blockquote>
      <Script
        async
        src="https://platform.twitter.com/widgets.js"
        strategy="afterInteractive"
      />
    </>
  );
};
